import { Container } from '../../Container/Container';
import BackButton from '../../BackButton/BackButton';
import History from './components/History/History';
import Logout from '../../Icons/Logout';
import styles from './AccountPage.module.scss';
import { logout } from '../../../api/user/logout';
import { useNavigate } from 'react-router-dom';
import { useGetOrders } from '../../../queries/orders/useGetOrders';
import Cookies from 'react-cookies';
import useAuth from '../../../hooks/useAuth';

const AccountPage = () => {
  const { userData } = useAuth();
  const { setAuth, setUserData } = useAuth();
  const navigate = useNavigate();

  const logoutFunc = () => {
    logout(Cookies.load('payload-token') || null).then((res) => {
      if (res) {
        Cookies.remove('payload-token');
        Cookies.remove('isUser');
        setAuth(false);
        setUserData(null);
        navigate('/login', { replace: true });
      }
    });
  };

  const { orders, isGetOrdersError, isGetOrdersLoading } = useGetOrders(
    Cookies.load('payload-token') || null,
  );

  return (
    <div className={styles.AccountPage}>
      <Container>
        <BackButton />
        <div className={styles.header}>
          <h1>Профиль</h1>
          <button className={styles.btn_logout} onClick={() => logoutFunc()}>
            <Logout />
            Выйти <span>из аккаунта</span>
          </button>
        </div>
        <div className={styles.info}>
          {userData?.email && <span>Имя пользователя: {userData?.email}</span>}
        </div>

        {isGetOrdersLoading ? (
          <div className={styles.message}>
            <p>Загрузка...</p>
          </div>
        ) : isGetOrdersError ? (
          <div className={styles.message}>
            <p>Ошибка загрузки истории заказов. Пожалуйста, попробуйте позже</p>
          </div>
        ) : orders && orders.docs.length ? (
          <History data={orders.docs} />
        ) : (
          <div className={styles.message}>
            <p>Здесь пока пусто</p>
          </div>
        )}
      </Container>
    </div>
  );
};

export default AccountPage;
